import { render, staticRenderFns } from "./SustainabilityChart.vue?vue&type=template&id=3e9a4e4b&scoped=true&"
import script from "./SustainabilityChart.vue?vue&type=script&lang=js&"
export * from "./SustainabilityChart.vue?vue&type=script&lang=js&"
import style0 from "./SustainabilityChart.vue?vue&type=style&index=0&id=3e9a4e4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9a4e4b",
  null
  
)

export default component.exports